var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.5c-2-2-5.1-2-7.1 0l-.4.4c-.6.6-.6 1.5 0 2.1.6.6 1.5.6 2.1 0l.4-.4c.8-.8 2-.8 2.8 0 .8.8.8 2 0 2.8l-2.8 2.8c-1 1-2.1.7-2.8 0l-2.1 2.1c1.8 1.8 4.9 2.1 7.1 0l2.8-2.8c2-1.8 2-5 0-7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7 17.4c2 2 5.1 2 7.1 0l.4-.4c.6-.6.6-1.5 0-2.1-.6-.6-1.5-.6-2.1 0l-.4.4c-.8.8-2 .8-2.8 0-.8-.8-.8-2 0-2.8l2.8-2.8c1-1 2.1-.7 2.8 0l2.1-2.1c-1.8-1.8-4.9-2.1-7.1 0l-2.8 2.8c-2 1.9-2 5 0 7z"
  })));
};
export default SvgLink;